<template>
  <div>
    <Head :title="title" />
    <div class="min-h-screen bg-indigo-50 pb-10">
      <nav class="border-b border-gray-100 bg-white">
        <!-- Primary Navigation Menu -->
        <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div class="flex h-16 justify-between">
            <div class="flex">
              <!-- Logo -->
              <div class="flex shrink-0 items-center">
                <Link :href="route('talent.finder')">
                  <div class="flex space-x-4">
                    <jet-application-mark class="block h-7 w-auto pr-4" />
                  </div>
                </Link>

                <!-- Navigation Links -->
                <div class="hidden space-x-4 pr-4 sm:-my-px sm:ml-6 sm:flex">
                  <jet-nav-link
                    :href="route('talent.finder')"
                    :active="route().current('talent.finder')"
                  >
                    Talent Finder
                  </jet-nav-link>
                  <jet-nav-link
                    :href="route('jobs.index')"
                    :active="route().current('jobs.*')"
                  >
                    Jobs
                  </jet-nav-link>
                  <!-- <jet-nav-link
                    :href="route('candidates.index')"
                    :active="route().current('candidates.*')"
                  >
                    Candidates
                  </jet-nav-link> -->
                  <jet-nav-link
                    :href="route('resumes.index')"
                    :active="route().current('resumes.*')"
                  >
                    Candidates
                  </jet-nav-link>
                  <jet-nav-link
                    :href="route('b2b.index')"
                    :active="route().current('b2b.*')"
                    v-if="$page.props.user?.current_client?.can_access_b2b_features"
                  >
                    Clients
                  </jet-nav-link>
                  <jet-nav-link
                    :href="route('conversations.index')"
                    :active="route().current('conversations.*')"
                  >
                    <span class="inline-flex items-center gap-2">
                      <span>Conversations</span>
                      <span
                        v-if="$page.props.user?.conversation_notifications_count > 0"
                        class="inline-flex min-w-[1.25rem] items-center justify-center rounded-full bg-red-500 px-1.5 py-0.5 text-[11px] font-semibold leading-none text-white"
                      >
                        {{ $page.props.user.conversation_notifications_count }}
                      </span>
                    </span>
                  </jet-nav-link>
                </div>
              </div>
            </div>

            <div class="hidden sm:ml-6 sm:flex sm:items-center">
              <div class="relative ml-3">
                <!-- <button
                  type="button"
                  class="rounded-full bg-white p-1 text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                >
                  <span class="sr-only">View notifications</span>
                  <BellIcon
                    class="h-6 w-6"
                    aria-hidden="true"
                  />
                </button> -->
                <!-- Clients Dropdown -->
                <jet-dropdown
                  align="left"
                  width="80"
                  v-if="
                    $page.props.user?.current_client?.is_recruitment_agency &&
                    $page.props.user?.current_client_customer_id
                  "
                >
                  <template #trigger>
                    <span
                      class="inline-flex rounded-md"
                      style="min-width: 220px; max-width: 220px"
                    >
                      <button
                        type="button"
                        class="inline-flex w-full items-center justify-between rounded-md border border-transparent bg-white px-3 py-2 text-sm font-medium leading-4 text-gray-500 transition hover:bg-gray-50 hover:text-gray-700 focus:bg-gray-50 focus:outline-none active:bg-gray-50"
                      >
                        <div class="flex items-center space-x-2 truncate">
                          <img
                            class="inline-block h-8 w-8 rounded-md"
                            :src="$page.props.user?.current_client_customer?.logo"
                            :alt="`${$page.props.user?.current_client_customer?.name}'s Logo'`"
                          />

                          <span class="text-md truncate">{{
                            $page.props.user?.current_client_customer?.name
                          }}</span>
                        </div>
                        <svg
                          class="-mr-0.5 ml-2 h-4 w-4"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                            clip-rule="evenodd"
                          />
                        </svg>
                      </button>
                    </span>
                  </template>

                  <template #content>
                    <div
                      class="h-64 w-72"
                      style="max-height: 16rem; min-height: 10rem"
                    >
                      <div class="non-closable border-b px-4 py-2">
                        <input
                          type="text"
                          class="w-full rounded-md border-0 bg-gray-100 px-4 py-2.5 text-gray-900 focus:ring-0 sm:text-sm"
                          placeholder="Search clients..."
                          role="combobox"
                          aria-expanded="false"
                          aria-controls="options"
                          v-model="searchClientCustomersQuery"
                          @input="searchClientCustomers"
                          autofocus
                        />
                      </div>

                      <!-- Client Settings -->
                      <!-- <jet-dropdown-link
                        :href="route('account.members', $page.props.user?.current_client)"
                      >
                        Team Settings
                      </jet-dropdown-link> -->

                      <div class="h-full overflow-y-auto bg-white">
                        <template v-if="$page.props.user?.all_client_customers?.length > 0">
                          <template
                            v-for="clientCustomer in filteredClients"
                            :key="clientCustomer.id"
                          >
                            <form @submit.prevent="switchToClientCustomer(clientCustomer)">
                              <jet-dropdown-link as="button">
                                <div class="flex items-center justify-between">
                                  <div class="flex space-x-2 truncate">
                                    <img
                                      class="inline-block h-10 w-10 rounded-md"
                                      :src="clientCustomer.logo"
                                      :alt="`${clientCustomer.name}'s Logo'`"
                                    />
                                    <div class="ml-4 flex-auto truncate">
                                      <p class="truncate text-sm font-medium text-gray-700">{{
                                        clientCustomer.name
                                      }}</p>
                                      <p class="truncate text-sm capitalize text-gray-500">{{
                                        clientCustomer.location
                                      }}</p>
                                    </div>
                                  </div>
                                  <CheckIcon
                                    class="h-4 w-4 text-gray-500"
                                    v-if="
                                      clientCustomer.id ==
                                      $page.props.user?.current_client_customer_id
                                    "
                                  />
                                </div>
                              </jet-dropdown-link>
                            </form>
                          </template>
                        </template>
                      </div>
                      <div class="bg-white">
                        <div class="border-t border-gray-100"></div>
                        <jet-dropdown-link :href="route('clients.customers.create')">
                          <div class="flex w-full items-center space-x-1">
                            <PlusIcon class="h-3 w-3" />
                            <span>Add a new client</span>
                          </div>
                        </jet-dropdown-link>
                      </div>
                    </div>
                  </template>
                </jet-dropdown>
              </div>
              <div
                class="relative"
                v-if="$page.props.user?.current_client?.is_recruitment_agency"
              >
                <div
                  class="w-6 rotate-90 bg-gray-400"
                  style="height: 1px"
                ></div>
              </div>
              <!-- Settings Dropdown -->
              <div class="relative ml-3">
                <jet-dropdown
                  align="right"
                  width="48"
                >
                  <template #trigger>
                    <button
                      v-if="$page.props.jetstream.managesProfilePhotos"
                      class="flex items-center rounded-full border-2 border-transparent text-sm transition focus:outline-none"
                    >
                      <img
                        class="h-8 w-8 rounded-full object-cover"
                        :src="$page.props.user?.profile_photo_url"
                        :alt="$page.props.user?.name"
                      />
                    </button>

                    <span
                      v-else
                      class="inline-flex rounded-md"
                    >
                      <button
                        type="button"
                        class="inline-flex items-center rounded-md border border-transparent bg-white px-3 py-2 text-sm font-medium leading-4 text-gray-500 transition hover:text-gray-700 focus:outline-none"
                      >
                        {{ $page.props.user?.name }}

                        <svg
                          class="-mr-0.5 ml-2 h-4 w-4"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                            clip-rule="evenodd"
                          />
                        </svg>
                      </button>
                    </span>
                  </template>

                  <template #content>
                    <Link
                      :href="item.href"
                      v-for="item in subNavigation"
                      :key="item.name"
                      class="flex px-4 py-2 text-sm leading-5 transition hover:bg-gray-100 focus:bg-gray-100 focus:outline-none"
                      :class="[
                        route().current(item.route) ? 'bg-gray-100 text-gray-700' : 'text-gray-700',
                      ]"
                    >
                      <component
                        :is="item.icon"
                        :class="[
                          route().current(item.route)
                            ? 'text-gray-700 group-hover:text-gray-700'
                            : 'text-gray-500 group-hover:text-gray-500',
                          '-ml-1 mr-3 h-5 w-5 flex-shrink-0',
                        ]"
                        aria-hidden="true"
                      />
                      <span class="truncate">{{ item.name }}</span>
                    </Link>

                    <div class="border-t border-gray-100"></div>
                    <!-- Authentication -->
                    <form
                      method="POST"
                      @submit.prevent="stopImpersonating"
                      v-if="$page.props.app?.impersonating"
                    >
                      <jet-dropdown-link as="button"> Stop Impersonating </jet-dropdown-link>
                    </form>
                    <form @submit.prevent="logout">
                      <jet-dropdown-link as="button"> Log Out </jet-dropdown-link>
                    </form>
                  </template>
                </jet-dropdown>
              </div>
            </div>

            <!-- Hamburger -->
            <div class="-mr-2 flex items-center sm:hidden">
              <button
                @click="showingNavigationDropdown = !showingNavigationDropdown"
                class="inline-flex items-center justify-center rounded-md p-2 text-gray-400 transition hover:bg-gray-100 hover:text-gray-500 focus:bg-gray-100 focus:text-gray-500 focus:outline-none"
              >
                <svg
                  class="h-6 w-6"
                  stroke="currentColor"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    :class="{
                      hidden: showingNavigationDropdown,
                      'inline-flex': !showingNavigationDropdown,
                    }"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                  <path
                    :class="{
                      hidden: !showingNavigationDropdown,
                      'inline-flex': showingNavigationDropdown,
                    }"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>

        <!-- Responsive Navigation Menu -->
        <div
          :class="{block: showingNavigationDropdown, hidden: !showingNavigationDropdown}"
          class="sm:hidden"
        >
          <div class="space-y-1 pb-3 pt-2">
            <jet-responsive-nav-link
              :href="route('talent.finder')"
              :active="route().current('talent.finder')"
            >
              Dashboard
            </jet-responsive-nav-link>
          </div>

          <!-- Responsive Settings Options -->
          <div class="border-t border-gray-200 pb-1 pt-4">
            <div class="flex items-center px-4">
              <div
                v-if="$page.props.jetstream.managesProfilePhotos"
                class="mr-3 shrink-0"
              >
                <img
                  class="h-10 w-10 rounded-full object-cover"
                  :src="$page.props.user?.profile_photo_url"
                  :alt="$page.props.user?.name"
                />
              </div>

              <div>
                <div class="text-base font-medium text-gray-800">{{ $page.props.user?.name }}</div>
                <div class="text-sm font-medium text-gray-500">{{ $page.props.user?.email }}</div>
              </div>
            </div>

            <div class="mt-3 space-y-1">
              <Link
                :href="item.href"
                v-for="item in subNavigation"
                :key="item.name"
                class="flex border-l-4 py-2 pl-3 pr-4 text-base font-medium transition"
                :class="[
                  route().current(item.route)
                    ? 'border-indigo-400 bg-indigo-50 text-indigo-700 focus:border-indigo-700 focus:bg-indigo-100 focus:text-indigo-800 focus:outline-none'
                    : 'border-transparent text-gray-600 hover:border-gray-300 hover:bg-gray-50 hover:text-gray-800 focus:border-gray-300 focus:bg-gray-50 focus:text-gray-800 focus:outline-none',
                ]"
              >
                <component
                  :is="item.icon"
                  :class="[
                    route().current(item.route)
                      ? 'text-indigo-700 group-hover:text-indigo-700'
                      : 'text-gray-600 group-hover:text-gray-600',
                    '-ml-1 mr-3 h-5 w-5 flex-shrink-0',
                  ]"
                  aria-hidden="true"
                />
                <span class="truncate">{{ item.name }}</span>
              </Link>

              <!-- Authentication -->
              <form
                method="POST"
                @submit.prevent="stopImpersonating"
                v-if="$page.props.app?.impersonating"
              >
                <jet-responsive-nav-link as="button"> Stop Impersonating </jet-responsive-nav-link>
              </form>
              <form
                method="POST"
                @submit.prevent="logout"
              >
                <jet-responsive-nav-link as="button"> Log Out </jet-responsive-nav-link>
              </form>

              <!-- Client Management -->
              <template v-if="$page.props.user?.current_client?.is_recruitment_agency">
                <div class="border-t border-gray-200"></div>

                <div class="block px-4 py-2 text-xs text-gray-400"> Manage Clients </div>

                <!-- Client Settings -->
                <jet-responsive-nav-link
                  :href="route('clients.show', $page.props.user?.current_client)"
                  :active="route().current('clients.show')"
                >
                  Client Settings
                </jet-responsive-nav-link>

                <jet-responsive-nav-link
                  :href="route('clients.customers.create')"
                  :active="route().current('clients.customers.create')"
                >
                  Create New Client
                </jet-responsive-nav-link>

                <div class="border-t border-gray-200"></div>

                <!-- Client Switcher -->
                <div class="block px-4 py-2 text-xs text-gray-400"> Switch Clients </div>

                <template
                  v-for="clientCustomer in $page.props.user?.all_client_customers || []"
                  :key="clientCustomer.id"
                >
                  <form @submit.prevent="switchToClientCustomer(clientCustomer)">
                    <jet-responsive-nav-link as="button">
                      <div class="flex items-center">
                        <svg
                          v-if="clientCustomer.id == $page.props.user?.current_client_customer_id"
                          class="mr-2 h-5 w-5 text-green-400"
                          fill="none"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                        </svg>
                        <div>{{ clientCustomer.name }}</div>
                      </div>
                    </jet-responsive-nav-link>
                  </form>
                </template>
              </template>
            </div>
          </div>
        </div>
      </nav>

      <!-- Page Heading -->
      <header
        class="bg-white shadow"
        v-if="$slots.header"
      >
        <div class="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
          <slot name="header"></slot>
        </div>
      </header>

      <!-- Page Content -->
      <main>
        <slot></slot>
      </main>
    </div>

    <Footer />
    <ToastNotification :flash="$page.props.flash" />

    <ImportLinkedInTalents />

    <Notifications />
    <Modal />

    <div
      v-if="$page.props.app.impersonating"
      class="fixed bottom-6 right-6 z-50"
    >
      <button
        @click="stopImpersonating"
        class="group flex items-center justify-center space-x-2 rounded-full bg-amber-500 px-4 py-3 text-white shadow-lg transition-colors hover:bg-red-600 hover:shadow-xl"
        title="Stop Impersonating"
      >
        <div class="relative h-5 w-5 flex-shrink-0">
          <EyeIcon class="absolute h-5 w-5 transition-opacity group-hover:opacity-0" />
          <XCircleIcon
            class="absolute h-5 w-5 opacity-0 transition-opacity group-hover:opacity-100"
          />
        </div>
        <span class="w-[130px] text-left text-sm font-medium">
          <span class="group-hover:hidden">Impersonating</span>
          <span class="hidden group-hover:inline">Stop Impersonating</span>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import {defineComponent, h, computed} from 'vue';
import {usePage} from '@inertiajs/vue3';
import {Modal} from 'momentum-modal';
import JetApplicationMark from '@/Jetstream/ApplicationMark.vue';
import JetBanner from '@/Jetstream/Banner.vue';
import JetDropdown from '@/Jetstream/Dropdown.vue';
import JetDropdownLink from '@/Jetstream/DropdownLink.vue';
import JetNavLink from '@/Jetstream/NavLink.vue';
import JetResponsiveNavLink from '@/Jetstream/ResponsiveNavLink.vue';
import {
  BellIcon,
  IdentificationIcon,
  OfficeBuildingIcon,
  UserCircleIcon,
  CogIcon,
  CreditCardIcon,
  DocumentTextIcon,
  UsersIcon,
  ViewGridAddIcon,
  ChatAlt2Icon,
  EyeIcon,
  XCircleIcon,
  KeyIcon,
  LightningBoltIcon,
} from '@heroicons/vue/outline';
import {CheckIcon, PlusIcon} from '@heroicons/vue/solid';
import ToastNotification from '@/Components/ToastNotification.vue';
import ImportLinkedInTalents from '@/Components/ImportLinkedInTalents.vue';
import Notifications from '@/Shared/Notifications.vue';
import Footer from '@/Layouts/Partials/Footer.vue';
import impersonationSync from '@/impersonation-sync.js';

const getSubNavigation = (hasApiFeatures, isRecruitmentAgency, hasApplyFeatures) => {
  const items = [
    {
      name: 'Profile',
      href: route('account.profile'),
      icon: UserCircleIcon,
      route: 'account.profile',
    },
    {
      name: 'Company',
      href: route('account.company'),
      icon: OfficeBuildingIcon,
      route: 'account.company',
    },
    {
      name: 'Team Members',
      href: route('account.members'),
      icon: UsersIcon,
      route: 'account.members',
    },
    {
      name: 'Enriched Profiles',
      href: route('account.enriched-profiles'),
      icon: IdentificationIcon,
      route: 'account.enriched-profiles',
    },
    {
      name: 'Subscription & Plans',
      href: route('account.plans'),
      icon: CreditCardIcon,
      route: 'account.plans',
    },
    {
      name: 'Integrations',
      href: route('account.integrations'),
      icon: ViewGridAddIcon,
      route: 'account.integrations',
    },
    {
      name: 'Outreach Settings',
      href: route('account.outreach-settings.mail'),
      icon: ChatAlt2Icon,
      route: 'account.outreach-settings.mail',
    },
  ];

  if (hasApplyFeatures) {
    items.splice(items.findIndex(i => i.route === 'account.outreach-settings.mail'), 0, {
      name: 'Career Settings',
      href: route('account.career-settings'),
      icon: DocumentTextIcon,
      route: 'account.career-settings',
    });
  }

  if (isRecruitmentAgency) {
    items.splice(2, 0, {
      name: 'Portfolio Clients',
      href: route('clients.customers.index'),
      icon: ViewGridAddIcon,
      route: 'clients.customers.*',
    });
  }

  if (hasApiFeatures) {
    items.push(
      {
        name: 'API Tokens',
        href: route('account.api-tokens'),
        icon: KeyIcon,
        route: 'account.api-tokens',
      },
      {
        name: 'Webhooks',
        href: route('account.webhooks'),
        icon: LightningBoltIcon,
        route: 'account.webhooks*',
      }
    );
  }

  items.push({
    name: 'Settings',
    href: route('account.settings'),
    icon: CogIcon,
    route: 'account.settings',
  });

  return items;
};

export default defineComponent({
  props: {
    title: String,
  },

  components: {
    Modal,
    JetApplicationMark,
    JetBanner,
    JetDropdown,
    JetDropdownLink,
    JetNavLink,
    JetResponsiveNavLink,
    BellIcon,
    ToastNotification,
    ImportLinkedInTalents,
    Notifications,
    Footer,
    CheckIcon,
    PlusIcon,
    EyeIcon,
    XCircleIcon,
  },
  data() {
    return {
      showingNavigationDropdown: false,
      searchClientCustomersQuery: '',
      filteredClients: this.$page.props.user?.all_client_customers || [],
      previousImpersonationState: null,
    };
  },
  setup() {
    const page = usePage();
    const subNavigation = computed(() =>
      getSubNavigation(
        page.props.user?.current_client?.can_access_api_features,
        page.props.user?.current_client?.is_recruitment_agency,
        page.props.user?.current_client?.can_access_apply_features
      )
    );

    return {
      subNavigation,
    };
  },
  mounted() {
    const currentState = this.$page.props.app.impersonating;
    const lastKnownState = localStorage.getItem('impersonation_state');

    if (lastKnownState !== null && lastKnownState !== String(currentState)) {
      localStorage.setItem('impersonation_state', String(currentState));

      if (currentState) {
        impersonationSync.broadcast('started', {timestamp: Date.now()});
      } else {
        impersonationSync.broadcast('stopped', {timestamp: Date.now()});
      }
    } else {
      localStorage.setItem('impersonation_state', String(currentState));
    }
  },
  methods: {
    switchToClient(client) {
      this.$inertia.put(
        route('current-client.update'),
        {
          client_id: client.id,
        },
        {
          preserveState: false,
        }
      );
    },
    switchToClientCustomer(customer) {
      this.$inertia.put(
        route('current-client-customer.update'),
        {
          customer_id: customer.id,
        },
        {
          preserveState: false,
        }
      );
      this.searchClientCustomersQuery = '';
      this.filteredClients = this.$page.props.user?.all_client_customers || [];
    },
    searchClientCustomers() {
      const query = this.searchClientCustomersQuery.toLowerCase();
      const allCustomers = this.$page.props.user?.all_client_customers || [];
      this.filteredClients = allCustomers.filter(
        clientCustomer =>
          clientCustomer.name.toLowerCase().includes(query) ||
          clientCustomer.location.toLowerCase().includes(query)
      );
    },
    logout() {
      this.$inertia.post(route('logout'));
    },
    stopImpersonating() {
      localStorage.setItem('impersonation_state', 'false');
      impersonationSync.broadcast('stopped', {timestamp: Date.now()});

      setTimeout(() => {
        this.$inertia.post(route('impersonation'));
      }, 100);
    },
  },
});
</script>
